export const initialBulkDetailsState = {
    bulk: {
        content: {
            id: "",
            slug: "",
            descrizione: "",
            associatedSims: "",
            amount: "",
            bulkType: "",
            commercialLabel: "",
            productName: "",
            kamDescription: "",
            customerPriceRic: "",
            customerPriceUt: "",
            activationTime: "",
            groupKey: "",
            groupCode: "",
            idTrattativa: "",
            planDescription: "",
            isCondiviso: false,
            simAssociate: "",
            simConsociate: "",
            showAssociaFlag: false,
        },
        loading: false
    },
    offer: {
        data: {
            planName: "",
            planDescription: "",
            commercialLabel: "",
            offertaTopItemList: [],
            offertaZoneItemList: [],
            opzioniGettoniDtoList: []
        },
        loading: false
    },
    associatedSims: {
        data: [],
        loading: false
    },
    notAssociatedSims: {
        data: [],
        loading: false
    },
    associateActionLoading: false,
    disassociateActionLoading: false
}

export const initialBulkCardsState = {
    data: {
        bulkList: [],
        holdingName: '',
        holdingIntegrationId: '',
        bulkListHolding: [],
    },
    loading: false
}

export const initialPlanOptionsForSim = {
    items: [],
    currentOffer: {
        planName: "",
        planDescription: "",
        commercialLabel: "",
        offertaTopItemList: [],
        offertaZoneItemList: [],
        opzioniGettoniDtoList: []
    },
    selectedPlanOffer: {
        data: {
            planName: "",
            planDescription: "",
            commercialLabel: "",
            offertaTopItemList: [],
            offertaZoneItemList: [],
            opzioniGettoniDtoList: []
        },
        loading: false
    },
    loading: false
}

export const initialTokenOptions = {
    addOptions: [],
    removeOptions: [],
    loading: false
}
